import { render, staticRenderFns } from "./returngoodsorders.vue?vue&type=template&id=5bff604c&scoped=true"
import script from "./returngoodsorders.vue?vue&type=script&lang=js"
export * from "./returngoodsorders.vue?vue&type=script&lang=js"
import style0 from "./returngoodsorders.vue?vue&type=style&index=0&id=5bff604c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff604c",
  null
  
)

export default component.exports